import { useState } from "react"
import { useNavigate } from "react-router-dom"
import Header from "@/components/layout/Header"
import Footer from "@/components/layout/Footer"
import { Button } from "@/components/ui/button"
import { Card, CardContent } from "@/components/ui/card"
import { Input } from "@/components/ui/input"
import { Label } from "@/components/ui/label"
import { getGuestOrderDetail } from "@/api/orderApi"

export default function GuestOrderLookupPage() {
  const navigate = useNavigate()
  const [form, setForm] = useState({ orderNo: "", orderPassword: "" })
  const [loading, setLoading] = useState(false)

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setForm(prev => ({ ...prev, [e.target.id]: e.target.value }))
  }

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    if (!form.orderNo || !form.orderPassword) {
      return alert("주문번호와 비밀번호를 모두 입력해주세요.")
    }

    try {
      setLoading(true)
      // 💡 백엔드에 데이터 검증 요청
      await getGuestOrderDetail(form)

      // 💡 성공하면 기존 '주문 상세 페이지'로 이동하되, state로 비밀번호를 넘겨서 권한을 부여함
      navigate(`/order/${form.orderNo}`, { state: { orderPassword: form.orderPassword } })
    } catch (error) {
      alert("주문 내역을 찾을 수 없거나 비밀번호가 일치하지 않습니다.")
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="min-h-screen bg-slate-50 text-slate-900 flex flex-col">
      <Header />
      <main className="flex-1 flex items-center justify-center p-4">
        <Card className="w-full max-w-md rounded-[28px] border border-slate-200 shadow-sm p-6 sm:p-8">
          <CardContent className="p-0">
            <div className="text-center mb-8">
              <h1 className="text-2xl font-bold">비회원 주문 조회</h1>
              <p className="mt-2 text-sm text-slate-500">주문 시 입력하신 주문번호와 비밀번호를 입력해주세요.</p>
            </div>

            <form onSubmit={handleSubmit} className="space-y-5">
              <div className="space-y-2">
                <Label htmlFor="orderNo">주문번호</Label>
                <Input id="orderNo" value={form.orderNo} onChange={handleChange} placeholder="예: ORD-171829..." className="h-12 rounded-xl" />
              </div>
              <div className="space-y-2">
                <Label htmlFor="orderPassword">주문 비밀번호</Label>
                <Input id="orderPassword" type="password" value={form.orderPassword} onChange={handleChange} placeholder="주문 시 설정한 비밀번호" className="h-12 rounded-xl" />
              </div>

              <Button type="submit" disabled={loading} className="w-full h-12 rounded-2xl bg-slate-900 hover:bg-slate-800 text-white font-bold mt-4">
                {loading ? "조회 중..." : "주문 내역 조회하기"}
              </Button>
            </form>
          </CardContent>
        </Card>
      </main>
      <Footer />
    </div>
  )
}